// @flow
import React, { PureComponent } from 'react';
import URI from 'urijs';
import { get } from 'lodash';

import { windowWrapper } from '@clubmed/utils';

import ReactAppContext from 'Context/ReactAppContext';
import { handle401GraphqlErrorSeller, isSeller } from 'Utils/seller/sellerUtils';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { ThreeSixty } from './ThreeSixty.jsx';

type State = {
  i18n: ?CMSContent,
  cxoMainContact: ?string,
  cxoLastResorts: Array<{
    id: string,
    name: string,
    category: Array<string>,
  }>,
  shouldRender: boolean,
};

export class ThreeSixtyContainer extends PureComponent<{}, State> {
  static contextType = ReactAppContext;

  cxoMainContactId: string;

  constructor(props: {}, context: *) {
    super(props, context);

    const { cxo_primarycontact: cxoMainContactId, cxo_village: cxoLastResorts = [] } = new URI(
      windowWrapper.getLocation() || '',
    ).search(true);

    // when there is always one village it's not an array so we need to force it
    const arrayCxoLastResorts = Array.prototype.concat(cxoLastResorts);
    this.cxoMainContactId = cxoMainContactId;
    this.state = {
      i18n: null,
      cxoMainContact: null,
      cxoLastResorts: arrayCxoLastResorts.map(resort => {
        const [resortId, roomCategories] = resort.split(' ');

        return {
          id: resortId,
          name: resortId,
          category: roomCategories.split(','),
        };
      }),
      shouldRender: isSeller(context) && cxoMainContactId && cxoLastResorts.length > 0,
    };
  }

  async componentDidMount() {
    if (!this.state.shouldRender) {
      return;
    }

    try {
      const { resorts, config, profile } = await graphQLClient.runNoCacheQuery(
        `{
        resorts(resortIds: ["${this.state.cxoLastResorts.map(({ id }) => id).join('","')}"]) {
          id
          name
        }
        config {
          booking {
            cxo {
              v360 {
                resortsAndRooms
              }
            }
          }
        }
        profile(userId: "${this.cxoMainContactId}", throw401Error: true) {
          firstName
          lastName
        }
    }`,
        this.context,
      );

      this.setState({
        i18n: config,
        cxoMainContact: `${profile.firstName} ${profile.lastName}`,
        cxoLastResorts: this.state.cxoLastResorts.map(resort => ({
          ...resort,
          name: get(resorts.find(({ id }) => id === resort.id), 'name', resort.id),
        })),
        shouldRender: true,
      });
    } catch (errors) {
      handle401GraphqlErrorSeller(errors, this.context);
    }
  }

  render() {
    if (!this.state.shouldRender || !this.state.cxoMainContact) {
      return null;
    }

    return (
      <ThreeSixty
        clientName={this.state.cxoMainContact}
        lastVisitsLabel={get(this.state.i18n, 'booking.cxo.v360.resortsAndRooms')}
        // $FlowFixMe
        lastVisits={this.state.cxoLastResorts}
      />
    );
  }
}
